export default function PepeLogo({ className = "w-9 h-9" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      aria-label="Pepe Butt logo"
      role="img"
    >
      <circle cx="22" cy="18" r="11" fill="#5BB03B" stroke="#050505" strokeWidth="2.5" />
      <circle cx="42" cy="18" r="11" fill="#5BB03B" stroke="#050505" strokeWidth="2.5" />
      <ellipse cx="32" cy="40" rx="24" ry="18" fill="#5BB03B" stroke="#050505" strokeWidth="2.5" />
      <ellipse cx="22" cy="17" rx="6.5" ry="7.5" fill="#FFFFFF" stroke="#050505" strokeWidth="1.5" />
      <ellipse cx="42" cy="17" rx="6.5" ry="7.5" fill="#FFFFFF" stroke="#050505" strokeWidth="1.5" />
      <circle cx="24" cy="18" r="3" fill="#050505" />
      <circle cx="40" cy="18" r="3" fill="#050505" />
      <path d="M13 44 Q32 56 51 42" fill="none" stroke="#B4654A" strokeWidth="5" strokeLinecap="round" />
      <path d="M13 44 Q32 56 51 42" fill="none" stroke="#050505" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
